module.exports = __webpack_public_path__ + "img/lookbook_8_right.eda28eb0.png";